/* StickyAtc — decoded 1:1 from Shrine PRO (js.shrinetheme.com/js/v2/main.js) */
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === 'true' ? 'after_scroll' : 'always');
    this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0);
    this.isScrollBtn = this.dataset.scrollBtn === 'true';
    this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section);
    this.floatingBtns = document.querySelectorAll('.floating-btn');
    this.footerSpacing();
    if (this.displayMode === 'always') {
      this.floatingBtns.forEach((btn) => { btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px'); });
    } else {
      this.checkScroll();
      document.addEventListener('scroll', this.checkScroll.bind(this));
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn');
      this.scrollDestination = document.querySelector('' + this.dataset.scrollDestination.replace('id', this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this));
    }
  }
  checkScroll() {
    let show = false;
    if (this.displayMode === 'after_scroll') {
      if (!this.mainAtcBtn) return;
      const top = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
      const bottom = top + this.mainAtcBtn.offsetHeight;
      show = window.scrollY > bottom;
    } else if (this.displayMode === 'after_pixels') {
      show = window.scrollY > this.displayThreshold;
    } else if (this.displayMode === 'after_percent') {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      show = scrollable <= 0 ? true : (window.scrollY / scrollable) * 100 > this.displayThreshold;
    }
    if (show) { this.style.transform = 'none'; this.scrolledPast = true; }
    else { this.style.transform = ''; this.scrolledPast = false; }
    this.floatingBtns.forEach((btn) => { btn.style.setProperty('--sticky-atc-offset', this.scrolledPast ? this.offsetHeight + 'px' : '0px'); });
  }
  handleScrollBtn() {
    const header = document.querySelector('sticky-header');
    const headerHeight = header ? header.clientHeight : 0;
    const destTop = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: destTop - headerHeight - 15, behavior: 'smooth' });
  }
  footerSpacing() {
    let spacer = document.querySelector('.sticky-atc-footer-spacer');
    if (spacer) return;
    spacer = document.createElement('div');
    spacer.className = 'sticky-atc-footer-spacer';
    spacer.style.height = this.clientHeight - 1 + 'px';
    spacer.style.display = 'block';
    const footer = document.querySelector('.footer');
    if (footer) spacer.style.background = window.getComputedStyle(footer).background;
    document.body.appendChild(spacer);
  }
}
if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
